module.exports = __webpack_public_path__ + "static/media/edit.c92887f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/edit.svg
// module id = 178
// module chunks = 0